export default __webpack_public_path__ + "static/media/showcase.32fdba0e.mov";